import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Form, Input, Radio } from "antd";
import "./style.scss";
import logo from "assets/cemlogo.png";
import { useDispatch } from "react-redux";
import { setLogin, setUser } from "state";
import { IForm } from "types";
import Swal from "sweetalert2";
import { api } from "services/api";

export const LoginPage = () => {
	const [canGo, setCanGo] = useState(false);
	const [loading, setLoading] = useState(false);
	const [type, setType] = useState<string>("student");
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const handleLogin = (values: IForm) => {
		const { email, password } = values;

		setLoading(true);

		api
			.post("/login", { email, password, type_auth: "email", section: type })
			.then((result) => {
				const {
					data: {
						data: { token, user },
					},
				} = result;

				const { id, username, person } = user;

				setLoading(false);

				localStorage.setItem(
					"token",
					JSON.stringify({
						token,
						person,
						user,
						id,
						username,
						email,
						label: type,
					})
				);

				dispatch(
					setLogin({
						email,
						password,
						name: person?.name,
						label: type,
						isAuthenticated: token !== undefined,
					})
				);

				dispatch(
					setUser({
						email,
						name: person?.name,
						label: type,
						id,
						username,
					})
				);

				navigate("/dash");
			})
			.catch((err) => {
				const status = err?.response?.status;
				const { feedback } = err?.response?.data;
				setLoading(false);
				if (
					status === 400 ||
					status === 404 ||
					status === 403 ||
					status === 401
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};

	return (
		<div className="login">
			<div className="login__container">
				<div className="login__container__header">
					<img src={logo} alt="logo" />
				</div>
				<div className="login__container__title">
					<h1>Acessar a plataforma</h1>
				</div>
				<div className="login__container__form">
					<Form
						name="basic"
						onFinish={(values) => handleLogin(values)}
						onFinishFailed={(error) => console.log(error)}
						autoComplete="off"
					>
						<div className="login__container__form__type">
							<Radio.Group
								onChange={(e) => setType(e.target.value)}
								defaultValue={"student"}
							>
								<Radio value={"student"}>Estudante</Radio>
								<Radio value={"manager"}>Gestor</Radio>
							</Radio.Group>
						</div>
						<Form.Item
							name={"email"}
							rules={[
								{
									required: true,
									message: "E-mail necessário",
								},
							]}
						>
							<Input
								placeholder={"E-mail"}
								id="userinfo"
								onChange={(e) =>
									setCanGo(
										e.target.value !== "" &&
											e.target.value.includes("@") &&
											// @ts-ignore
											document.getElementById("basic_password").value !== ""
									)
								}
							/>
						</Form.Item>

						<Form.Item
							name="password"
							rules={[{ required: true, message: "Senha necessária" }]}
						>
							<Input.Password
								placeholder="Senha"
								onChange={(e) =>
									setCanGo(
										e.target.value !== "" &&
											// @ts-ignore
											document.getElementById("userinfo").value !== "" &&
											// @ts-ignore
											document.getElementById("userinfo").value.includes("@")
									)
								}
							/>
						</Form.Item>

						<Form.Item>
							<Button
								loading={loading}
								type="primary"
								htmlType="submit"
								disabled={!canGo}
							>
								Entrar
							</Button>
						</Form.Item>
					</Form>
					<div className="login__container__forget">
						<Link to={"/recover-password"}>Esqueci minha senha</Link>
					</div>
					<hr />
					<div className="login__container__footer">
						<Link to={"/signup"}>Criar nova conta</Link>
					</div>
				</div>
			</div>
		</div>
	);
};
